import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

const breakePoints = {
    sDesktop: '1187px',
    tablet: '859px',
    mobile: '640px',
};

export const Advantage = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: flex-start;
    width: 100%;
    padding: 0 40px;

    @media (max-width: 1279px) {
        padding: 0 20px;
    }

    @media (max-width: ${breakePoints.sDesktop}) {
        flex-direction: row;
        padding: 0;
    }

    @media (max-width: ${breakePoints.mobile}) {
        flex-direction: column;
    }
`;

export const AdvantageImageWrap = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    width: auto;
    height: 106px;
    margin-bottom: 40px;

    @media (max-width: ${breakePoints.sDesktop}) {
        justify-content: center;
        width: 100px;
        height: 72px;
        margin-right: 24px;
        margin-bottom: 0;
    }

    @media (max-width: ${breakePoints.mobile}) {
        justify-content: flex-start;
        margin-bottom: 30px;
    }
`;

export const AdvantageImg = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;

    @media (max-width: ${breakePoints.sDesktop}) {
        width: auto;
        height: 100%;
    }
`;

export const AdvantageDescription = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const AdvantageTitle = styled.h3`
    width: 100%;
    margin-bottom: 15px;
    ${FONTS.H3};

    @media (max-width: ${breakePoints.sDesktop}) {
        ${FONTS.H4};
    }
`;

export const AdvantageText = styled.p`
    margin-bottom: 0;
    width: 100%;
    ${FONTS.S};
    opacity: 0.5;
`;
